module.exports = __webpack_public_path__ + "img/empty-data.53453c90.png";